import { render, staticRenderFns } from "./GlobalAllocationProductList.vue?vue&type=template&id=28ee88e4&scoped=true"
import script from "./GlobalAllocationProductList.vue?vue&type=script&lang=ts"
export * from "./GlobalAllocationProductList.vue?vue&type=script&lang=ts"
import style0 from "./GlobalAllocationProductList.vue?vue&type=style&index=0&id=28ee88e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ee88e4",
  null
  
)

export default component.exports